import {tokenDefinition} from "../../token/tokenDefinition.mjs";
import {TokenType} from  "../../token/tokenType.mjs";
import {TokenName} from "./tokenName.mjs";
import {NodeName} from "./nodeName.mjs";
import {Node} from "../../node/node.mjs";

const writingPractice = tokenDefinition({
  name: TokenName.WRITING_PRACTICE,
  type: TokenType.KEYWORD,
  tokenMatcher: /^@write\n/,
  contentMatcher: /^@write\n/
});

class WritingPractice {

  constructor() {
  }

  consume(tokenIterator, nodeIterator) {

    if(this.isOpening(tokenIterator)) {
      this.openNewNode(tokenIterator, nodeIterator)
    }else if(this.isClosing(tokenIterator)) {
      this.closeNode(tokenIterator, nodeIterator)
    }

  }

  isOpening(tokenIterator) {
    return tokenIterator.token()
        && tokenIterator.token().name === TokenName.WRITING_PRACTICE
  }

  openNewNode(tokenIterator, nodeIterator) {
    nodeIterator.addOpenNode(new Node(
        NodeName.WRITING_PRACTICE,
        tokenIterator.token().value,
        new WritingPractice(),
        nodeIterator.currentParentNode
    ))
    tokenIterator.eatTokens(1)
  }

  closeNode(tokenIterator, nodeIterator) {

    const writingNodeIndex = nodeIterator.indexOfLastOpen(NodeName.WRITING_PRACTICE)
    if(writingNodeIndex === null) return

    // close last open writing node
    nodeIterator.closeNodeAtIndex(writingNodeIndex)

    // eat only one line feed
    //tokenIterator.eatTokens(1)
  }

  isClosing(tokenIterator) {
    return !tokenIterator.token()
        || this.isDoubleLineFeed(tokenIterator)
  }

  isDoubleLineFeed(tokenIterator) {
    return tokenIterator.hasNext(2)
        && tokenIterator.token().name === TokenName.LINE_FEED
        && tokenIterator.peekNext(1).name === TokenName.LINE_FEED;
  }

  onEndOfMarkup(openNode) {
    openNode.close()
  }

  toHtml(node, toHtml, idProvider) {
    var content = ""
    for(const child of node.children) {
      content += toHtml(child, idProvider)
    }
    const id = idProvider.next()

    return `
    <form action='#' id='write-form__${id}' class='write-form'>
      ${content}
      <button type="button">Submit</button>
    </form>`

  }

}
export {writingPractice, WritingPractice}